import { Stack, Text } from 'braid-design-system';
import { InlineCode, SmartTextLink } from 'scoobie';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import { EventList } from './components/EventList/EventList.tsx';
import type { Breadcrumb } from '#src/components/Breadcrumbs/Breadcrumbs.tsx';

export const EventsPage = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => (
  <BasePage title="Event polling" breadcrumbs={breadcrumbs}>
    <Stack space="medium">
      <Text>
        View all events available for ingestion, beyond the lifetime of an
        individual webhook subscription.
      </Text>

      <Text>
        You can use the{' '}
        <SmartTextLink href="/schema/query/events">
          <InlineCode>events</InlineCode> query
        </SmartTextLink>{' '}
        in this manner to{' '}
        <SmartTextLink href="/events/polling#backfilling--reprocessing-flow">
          backfill and reprocess events
        </SmartTextLink>{' '}
        for disaster recovery or when remediating a webhook configuration issue.
      </Text>
    </Stack>

    <EventList />
  </BasePage>
);
